import React, { createContext, FunctionComponent, useRef } from "react";
import CustomerSocket from "./socket";

const CustomerSocketContext = createContext<CustomerSocket | undefined>(undefined);

export const CustomerSocketProvider: FunctionComponent<{
  url: string,
  token?: string,
}> = ({ children, url, token }) => {
  const customerSocket = useRef(new CustomerSocket({ url, token }))
  customerSocket.current.update({ url, token });
  return (
    <CustomerSocketContext.Provider
      value={customerSocket.current}
    >
      { children }
    </CustomerSocketContext.Provider>
  );
};

export default CustomerSocketContext;
